
import { Context } from '@nuxt/types'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'

export default MachinationsLightPage.extend({
  name: 'AcademyIndex',
  layout: 'docsLayout',
  key(route) {
    return 'academy-' + route.fullPath
  },
  data() {
    return {
      page: null,
    }
  },
  computed: {
    pageTitle(): string {
      return this.$store.state.wp.pageTitle || this.$t('wordCapitalLearn')
    },
  },
  methods: {},
  async asyncData(context: Context) {
    const { store } = context

    await store.dispatch('common/setupPageLight', { context })
    let chapters = []
    if (!store.state.academy.chaptersLoaded) {
      chapters = await store.dispatch('academy/loadChapters', {
        context,
      })
    }
    const pageDetails = await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'learn',
    })
    return {
      chapters,
      pageDetails,
    }
  },
})
